module.exports = __webpack_public_path__ + "static/media/ic_time.c344bfb9.svg";